import React from "react";
import { Heading } from "@hex-insights/core";
import { MarketEntranceStationForm } from "@hex-insights/roadium.shared";
import { useActivePageRegistration, useHistory } from "@hex-insights/router";
import { Main } from "../../../../Components";
import { marketEntranceStationHubDetailPageInfo } from "../DetailPage/pageinfo";
import { marketEntranceStationHubCreatePageInfo } from "./pageinfo";

export function MarketEntranceStationHubCreatePage() {
	useActivePageRegistration(marketEntranceStationHubCreatePageInfo);

	const { push: pushHistory } = useHistory();
	const onSuccess = React.useCallback<MarketEntranceStationForm.ControlledCreateProps["onSuccess"]>(
		({ id }) => {
			pushHistory(marketEntranceStationHubDetailPageInfo.to(id));
		},
		[pushHistory],
	);

	return (
		<Main>
			<Heading level={1}>New Market Entrance Station</Heading>

			<MarketEntranceStationForm.ControlledCreate onSuccess={onSuccess} />
		</Main>
	);
}
